import { useCallback, useState } from "react";

const ERROR_BORDER = "border-red-400 bg-red-50";

/** Show field errors only after blur (or after touchMany on submit/next). */
export function useBlurFieldErrors() {
  const [touched, setTouched] = useState({});
  const [forced, setForced] = useState(false);

  const touch = useCallback((key) => {
    setTouched((t) => (t[key] ? t : { ...t, [key]: true }));
  }, []);

  const touchMany = useCallback((keys) => {
    setForced(true);
    setTouched((t) => keys.reduce((a, k) => ({ ...a, [k]: true }), { ...t }));
  }, []);

  const reset = useCallback(() => {
    setTouched({});
    setForced(false);
  }, []);

  const show = useCallback((key) => forced || !!touched[key], [forced, touched]);

  const msg = useCallback((key, errorText) => (show(key) && errorText ? errorText : ""), [show]);

  const errCls = useCallback(
    (key, errorText, base = "") => (show(key) && errorText ? `${base} ${ERROR_BORDER}`.trim() : base),
    [show],
  );

  return { touch, touchMany, reset, show, msg, errCls };
}
